/**
 * "Cosa è in onda adesso" (POST /api/v3/now): fire-and-forget. L'invio è rimandato fuori dal percorso
 * critico del cambio di contenuto (setTimeout 0), senza retry né buffer. Gli errori di rete si ignorano;
 * 401/402/403 vengono passati a `onFatal` (stesso percorso degli altri endpoint).
 */
import { AuthError, DeviceDisabledError, SubscriptionInactiveError, type NowBody } from '../net/api';

export type NowSender = (body: NowBody) => Promise<void>;

export class NowNotifier {
  constructor(
    private readonly send: NowSender,
    private readonly onFatal: (e: unknown) => void,
    private readonly defer: (fn: () => void) => void = (fn) => { setTimeout(fn, 0); },
  ) {}

  show(info: { scheduleId: string | null; assetId: string; startedAt: string; durationMs: number | null }): void {
    this.post({ schedule_id: info.scheduleId, asset_id: info.assetId, started_at: info.startedAt, duration_ms: info.durationMs });
  }

  black(startedAt: string): void {
    this.post({ schedule_id: null, asset_id: null, started_at: startedAt, duration_ms: null });
  }

  private post(body: NowBody): void {
    this.defer(() => {
      let p: Promise<void>;
      try {
        p = this.send(body);
      } catch {
        return;
      }
      p.catch((e: unknown) => {
        if (e instanceof AuthError || e instanceof DeviceDisabledError || e instanceof SubscriptionInactiveError) {
          try { this.onFatal(e); } catch { /* ignorato */ }
        }
        // ogni altro errore (rete, timeout, 5xx): ignorato
      });
    });
  }
}
